let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4awiX")).then(() => parcelRequire('fSK3M'));